const getTextAlertValues = (updatedTextAlertPreferences, textAlertPreferences, fieldId) => (
  Object.hasOwn(updatedTextAlertPreferences, fieldId)
    ? updatedTextAlertPreferences?.[fieldId] : textAlertPreferences?.[fieldId]);

const getNewAlert = (alertId, active = true, overridesChildren = false) => ({ alertId, active, overridesChildren });
const getMobileProvidersList = (mobileProviders) => [{ id: 0, name: 'Select' }, ...mobileProviders];
export { getTextAlertValues, getNewAlert, getMobileProvidersList };
